const CHAT_COPY = {
  en: {
    messages: "Messages",
    all: "All",
    unread: "Unread",
    archived: "Archived",
    archiveChat: "Archive chat",
    unarchiveChat: "Unarchive chat",
    deleteChat: "Delete chat",
    newMessage: "New Message",
    searchNomad: "Type a nomad name...",
    friendsNewChat: "Friends - New Chat",
    backToMessages: "Back to messages",
    searchFriend: "Search a friend to start chatting",
    searchForFriend: "Search for a friend.",
    searchForFriendHint: "Type a name or nickname to start chatting.",
    noMatches: "No matches found.",
    tryAnotherName: "Try another name.",
    recent: "Recent",
    noMessages: "No messages",
    noChatsInView: "No chats in this view.",
    adjustFilter: "Adjust the filter or search for another contact.",
    today: "TODAY",
    selectConversation: "Select a conversation to start chatting.",
    noMessagesYet: "No messages yet",
    firstMessage: "Send the first message and start the conversation.",
    loadingConversation: "Loading conversation...",
    newestMessages: "Go to newest messages",
    selectChatWriting: "Select a chat to start writing",
    sending: "Sending...",
    writeMessage: "Write a message...",
    you: "You",
    selectChat: "Select a chat",
    backToChats: "Back to chats",
    openProfile: "Open profile",
    searchOrStart: "Search for a contact or start a new conversation",
    reactionFallbackMessage: "a message",
    reactedTo: ({ user, code, message }) => `${user} reacted ${code} to ${message}`,
    missingChatId: "Missing chat id.",
    chatArchived: "Chat archived.",
    archiveError: "Could not archive the chat.",
    chatDeleted: "Chat deleted.",
    deleteError: "Could not delete the chat.",
    cannotSendMessage: "This user does not allow receiving messages",
    verifyIdentityMessageStart: "You need to ",
    verifyIdentityLink: "verify your identity",
    verifyIdentityMessageEnd: " to send a message to another VivaNomada user",
  },
  es: {
    messages: "Mensajes",
    all: "Todos",
    unread: "No leidos",
    archived: "Archivados",
    archiveChat: "Archivar chat",
    unarchiveChat: "Desarchivar chat",
    deleteChat: "Eliminar chat",
    newMessage: "Nuevo mensaje",
    searchNomad: "Escribe el nombre de un nomada...",
    friendsNewChat: "Amigos - Nuevo chat",
    backToMessages: "Volver a mensajes",
    searchFriend: "Busca un amigo para empezar a chatear",
    searchForFriend: "Busca un amigo.",
    searchForFriendHint: "Escribe un nombre o apodo para empezar a chatear.",
    noMatches: "No se encontraron resultados.",
    tryAnotherName: "Prueba con otro nombre.",
    recent: "Recientes",
    noMessages: "Sin mensajes",
    noChatsInView: "No hay chats en esta vista.",
    adjustFilter: "Ajusta el filtro o busca otro contacto.",
    today: "HOY",
    selectConversation: "Selecciona una conversacion para empezar a chatear.",
    noMessagesYet: "Aun no hay mensajes",
    firstMessage: "Envia el primer mensaje e inicia la conversacion.",
    loadingConversation: "Cargando conversacion...",
    newestMessages: "Ir a los mensajes mas recientes",
    selectChatWriting: "Selecciona un chat para empezar a escribir",
    sending: "Enviando...",
    writeMessage: "Escribe un mensaje...",
    you: "Tu",
    selectChat: "Selecciona un chat",
    backToChats: "Volver a chats",
    openProfile: "Abrir perfil",
    searchOrStart: "Busca un contacto o inicia una nueva conversacion",
    reactionFallbackMessage: "un mensaje",
    reactedTo: ({ user, code, message }) => `${user} reacciono ${code} a ${message}`,
    missingChatId: "Falta el id del chat.",
    chatArchived: "Chat archivado.",
    archiveError: "No se pudo archivar el chat.",
    chatDeleted: "Chat eliminado.",
    deleteError: "No se pudo eliminar el chat.",
    cannotSendMessage: "Este usuario no permite recibir mensajes",
    verifyIdentityMessageStart: "Necesitas ",
    verifyIdentityLink: "verificar tu identidad",
    verifyIdentityMessageEnd: " para poder enviar mensaje a otro usuario de VivaNomada",
  },
};

const TEXT_KEYS = {
  messages: "LB0564",
};

export const getChatCopy = (lang = "en", texts = {}) => {
  const normalizedLang = String(lang || "en").toLowerCase().startsWith("es")
    ? "es"
    : "en";

  return {
    ...CHAT_COPY[normalizedLang],
    messages:
      texts?.[TEXT_KEYS.messages] ||
      CHAT_COPY[normalizedLang].messages ||
      (normalizedLang === "es" ? "Mensajes" : "Messages"),
  };
};
